import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {Page} from '../../../../page';
import {Produto} from './produto';

@Injectable({
    providedIn: 'root'
})
export class ProdutosService {

    constructor(private http: HttpClient) {
    }

    private baseUrl = environment.urlApi + '/api/pesquisa';

    getProdutos(filtros: Map<string, any>, tags: Array<string>, offset: number, limit: number): Observable<Page<Produto>> {
        return this.http.post<Page<Produto>>(this.baseUrl, { offset, limit, ...this.construirFiltros(filtros, tags) }, {});
    }

    construirFiltros(filtros: Map<string, any>, tags: Array<string>): any {
        const properties: { [K: string]: any } = {};

        filtros.forEach(function registrarFiltrosNoMapa(valor: any, chave: string) {
            properties[chave] = valor;
        });

        if (tags) {
            properties.tags = tags;
        }

        return {...properties};
    }

}
